<template>
  <label :class="[variant === 'static' ? '' : 'form-label', 'd-flex', 'align-items-center']" v-if="label">
    {{ label }}
    <span v-if="isRequired" class="text-danger">*</span>

    <Tooltip v-if="toolTipHeading && toolTipHeading != ''" :heading="toolTipHeading" :paragraph="toolTipDescription" />
  </label>

  <div class="input-group" :class="`input-group-${variant} ${getStatus(error, success)}`">
    <!-- Optional leading icon -->
    <span v-if="prependIcon" class="input-group-text">
      <i :class="prependIcon"></i>
    </span>

    <input
      :id="id || name"
      :type="type"
      class="form-control"
      :class="getClasses(size)"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="disabled"
      :readonly="readOnly"
      :min="min"
      :max="max"
      :style="[readOnly && { backgroundColor: '#f8f9fa' }, style]"
      @input="handleInput"
      @keyup="$emit('keyup', $event)"
    />
    <!-- Optional append slot -->
    <slot name="append"></slot>
  </div>
</template>

<!-- <script>
import setMaterialInput from "@/assets/js/material-input.js";
import Tooltip from "./Tooltip.vue";

export default {
  name: "MaterialInput",
  components: { Tooltip },
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    variant: {
      type: String,
      default: "outline",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    style: {
      type: [String, Object],
      default: "",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      // required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    toolTipHeading: {
      type: String,
      default: '',
    },
    toolTipDescription: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  mounted() {
    setMaterialInput();
  },
  methods: {
    handleInput(event) {
      const value = event.target.value;
      // If the input type is number, emit as a number, otherwise as string
      if (this.type === "number") {
        this.$emit("update:modelValue", value === "" ? null : Number(value));
      } else {
        this.$emit("update:modelValue", value);
      }
    },
    getClasses(size) {
      return size ? `form-control-${size}` : null;
    },
    getStatus(error, success) {
      if (success) return "is-valid";
      if (error) return "is-invalid";
      return null;
    },
  },
};
</script> -->

<script>
import setMaterialInput from "@/assets/js/material-input.js";
import Tooltip from "./Tooltip.vue";

export default {
  name: "MaterialInput",
  components: { Tooltip },
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    variant: {
      type: String,
      default: "outline",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    // Font Awesome / icon class to render before the input
    prependIcon: {
      type: String,
      default: "",
    },
    style: {
      type: [String, Object],
      default: "",
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: [String, undefined],
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    toolTipHeading: {
      type: String,
    },
    toolTipDescription: {
      type: String,
    },
    min: {
      type: [Number, String],
      default: undefined,
    },
    max: {
      type: [Number, String],
      default: undefined,
    },
  },
  emits: ["update:modelValue", "keyup"],
  mounted() {
    setMaterialInput();
  },
  methods: {
    handleInput(event) {
      let value = event.target.value;

      if (this.type === "number") {
        if (value === "") {
          this.$emit("update:modelValue", null);
          return;
        }
        
        let numValue = Number(value);
        
        // Enforce min constraint
        if (this.min !== undefined && numValue < Number(this.min)) {
          numValue = Number(this.min);
          event.target.value = this.min;
        }
        
        // Enforce max constraint
        if (this.max !== undefined && numValue > Number(this.max)) {
          numValue = Number(this.max);
          event.target.value = this.max;
        }
        
        this.$emit("update:modelValue", numValue);
      }
      else if (this.type === "time") {
        // Normalize to "HH:mm" 24-hour format
        const validTime = value && /^\d{2}:\d{2}$/.test(value)
          ? value
          : null;
        this.$emit("update:modelValue", validTime);
      }
      else {
        this.$emit("update:modelValue", value);
      }
    },
    getClasses(size) {
      return size ? `form-control-${size}` : null;
    },
    getStatus(error, success) {
      if (success) return "is-valid";
      if (error) return "is-invalid";
      return null;
    },
  },
};
</script>
